import React from 'react';

import { CartHandoffModal } from '@order/features-cart-handoff';

import { useIsLiquidGlassEnabled } from '../../hooks';

// ─────────────────────────────────────────────────────────────────────────────

export const CartHandoffScreen = () => {
  const isLiquidGlassEnabled = useIsLiquidGlassEnabled();

  return <CartHandoffModal isLiquidGlassEnabled={isLiquidGlassEnabled} />;
};
